import getOrganizationDropdown from "./organizationDropdown";

const organizations = {
  getOrganizationDropdown,
};

export default organizations;
